import approvalsHttp from "@/http/requests/approvals";
import notificationsHttp from "@/http/requests/notifications";

const token = () => localStorage.getItem('accessToken');

export default {
  async fetchPending({ commit }, filters = {}) {
    commit('SET_LOADING', true);
    try {
      const response = await approvalsHttp.pending(token(), filters);
      const data = response.data || {};
      commit('SET_PENDING', data.items || []);
      commit('SET_PENDING_PAGINATION', {
        totalPages: data.total_pages || 0,
        totalItems: data.total_items || 0
      });
      return data;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchRequests({ commit }, filters = {}) {
    commit('SET_LOADING', true);
    try {
      const response = await approvalsHttp.myRequests(token(), filters);
      const data = response.data || {};
      commit('SET_REQUESTS', data.items || []);
      commit('SET_REQUESTS_PAGINATION', {
        totalPages: data.total_pages || 0,
        totalItems: data.total_items || 0
      });
      return data;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchRequestById({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      const response = await approvalsHttp.find(token(), id);
      commit('SET_CURRENT_REQUEST', response.data || null);
      return response.data;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchOpenScheduleByTenant(_, tenantId) {
    const response = await approvalsHttp.openSchedule(token(), tenantId);
    return response.data || null;
  },

  async fetchTenantHistory(_, { tenantId, page, limit }) {
    const response = await approvalsHttp.tenantHistory(token(), tenantId, { page, limit });
    return response.data || null;
  },

  async exportTenantHistory(_, { tenantId }) {
    const response = await approvalsHttp.exportTenantHistory(token(), tenantId);
    return response.data || null;
  },

  async createRequest({ dispatch }, payload) {
    const response = await approvalsHttp.create(token(), payload);
    await dispatch('fetchRequests');
    return response.data;
  },

  async previewBulkRequests(_, payload) {
    const response = await approvalsHttp.previewBulk(token(), payload);
    return response.data;
  },

  async createBulkRequest({ dispatch }, payload) {
    const response = await approvalsHttp.createBulk(token(), payload);
    await dispatch('fetchRequests');
    return response.data;
  },

  async updateRequest({ dispatch }, { id, data }) {
    const response = await approvalsHttp.update(token(), id, data);
    await dispatch('fetchRequests');
    return response.data;
  },

  async cancelRequest({ dispatch }, { id, comment }) {
    const response = await approvalsHttp.cancel(token(), id, comment);
    await dispatch('fetchRequests');
    return response.data;
  },

  async decideRequest({ dispatch }, { id, decision, comment, roleRequired }) {
    const payload = {
      decision,
      comment,
      role_required: roleRequired
    };
    const response = await approvalsHttp.decide(token(), id, payload);
    await dispatch('fetchPending');
    await dispatch('fetchRequests');
    return response.data;
  },

  async executeRequest(_, { id, executedAt, result }) {
    const payload = {
      executed_at: executedAt,
      result
    };
    const response = await approvalsHttp.execute(token(), id, payload);
    return response.data;
  },

  setCurrentRequest({ commit }, request) {
    commit('SET_CURRENT_REQUEST', request);
  },

  async fetchNotifications({ commit }, params = {}) {
    const response = await notificationsHttp.list(token(), params);
    commit('SET_NOTIFICATIONS', response.data || []);
    return response.data;
  },

  async markNotificationsRead({ dispatch }, payload = {}) {
    const response = await notificationsHttp.markAsRead(token(), payload);
    await dispatch('fetchNotifications', { limit: 25 });
    return response.data;
  }
}
